import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=8de32722&scoped=true&"
import script from "./TextIcon.vue?vue&type=script&lang=js&"
export * from "./TextIcon.vue?vue&type=script&lang=js&"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=8de32722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de32722",
  null
  
)

export default component.exports